import { DEFAULT_PAGE_SIZE } from 'components/common/DataGridDevEx/DataGrid.constants';
import { fetchGet, objectify } from '../utils';

export const getComponentDetails = (query) => {
  const { Invoice, SalesEntity, LineNumber } = query;

  return fetchGet(`SalesInvoiceEnquiry/Entity/${SalesEntity}/SalesInvoice/${Invoice}/${LineNumber}/BillOfMaterial/Details`, null, 'Inline')
    .then((result) => (result && objectify(result.ComponentDetails)));
};

export const fetch = async (query: { SalesEntity: string; Invoice: string; LineNumber: number; Page: number; BatchSize?: number }): Promise<{ records: any[]; nextPage: boolean; currPage: number }> => {
  const { SalesEntity, Invoice, LineNumber, Page, BatchSize = DEFAULT_PAGE_SIZE } = query;
  const respType = 'Inline';

  return fetchGet(
    `SalesInvoiceEnquiry/Entity/${SalesEntity}/SalesInvoice/${Invoice}/${LineNumber}/BillOfMaterial`,
    {
      BatchPage: Page,
      BatchSize
    },
    respType)
    .then(
      (result: {
        BillOfMaterials: any[];
        BatchInformation: {
          BatchPage: number;
          EndOfData: boolean;
        };
      }) => {
        if (result) {
          if (result.BillOfMaterials) {

            return {
              records: result.BillOfMaterials.map((item: any) => objectify(item, null, 'Inline')),
              nextPage: result.BatchInformation && !result.BatchInformation.EndOfData,
              currPage: result.BatchInformation && result.BatchInformation.BatchPage,
            };
          }
        }

        return {
          records: [],
          nextPage: false,
          currPage: 1,
        };
      });
};
